import script from "./BaseIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseIcon.vue?vue&type=script&setup=true&lang=ts"

import "./BaseIcon.vue?vue&type=style&index=0&id=132014c1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-132014c1"]])

export default __exports__